<template>
    <div class="container p-3">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="alert alert-danger">
                    <!-- <h1>An error has occurred.</h1> -->
                    <ul v-for="i in failureMessages" :class="failureMessages.length < 2 ? ['list-unstyled', 'p-0'] : []">
                        <li>{{ i }}</li>
                    </ul>
                    <div v-if="actions.length > 0">
                        <div v-for="action in actions">
                            <button class="btn btn-primary" @click="act(action)">{{ action.Label }}</button>
                            <AsyncOperationStatus :promise="action.promise" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import getData from "../../admin/lib/getData";
import { fetchXsrf } from "@/lib/fetchHelpers.3";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
import { useMainStore } from "@/mainStore";
import { ResumeFailure } from "@cs/ResumeFailure";
type JsResumeFailure = Omit<ResumeFailure, "Actions"> & { Actions?: (NonNullable<ResumeFailure["Actions"]>[0] & { promise?: Promise<void> | null })[] };
export default defineComponent({
    components: {
        AsyncOperationStatus,
    },
    setup() {
        const mainStore = useMainStore();
        const extraData = ref(null as null | JsResumeFailure);
        const failureMessages = computed(() => {
            return extraData.value?.FailureMessages ?? [];
        });
        const actions = computed(() => {
            const result = extraData.value?.Actions ?? [];
            for (let act of result) {
                if (!("promise" in act)) {
                    act.promise = null; // eslint-disable-line vue/no-side-effects-in-computed-properties
                }
            }
            return result;
        });
        const act = async (action: NonNullable<JsResumeFailure["Actions"]>[0]) => {
            action.promise = (async () => {
                const url = await mainStore.getUrl(action.UrlType, action.UrlData);
                const response = await fetchXsrf(mainStore, url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "same-origin",
                    body: JSON.stringify(action.PostData),
                });
                if (response.status == 200) {
                    // TODO?
                } else {
                    throw new Error("Not 200 OK: " + response.status + " " + response.statusText);
                }
            })();
        };
        (async () => {
            extraData.value = (await getData(mainStore, "PageResumeFailure", () => {
                throw new Error();
            })) as JsResumeFailure;
        })();

        return {
            failureMessages,
            actions,
            act,
        };
    },
});
</script>
